import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { useAuth } from '../hooks/auth-provider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFire } from '@fortawesome/free-solid-svg-icons';
import i18n from '../i18n';

const publicUrl = process.env.PUBLIC_URL;
const appName = process.env.REACT_APP_NAME;

export const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useAuth();
    const toast = useRef(null);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (email && password) {
            login(email, password).then(
                () => {
                    window.location.href = publicUrl + '/';
                },
                () => {
                    toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: i18n.t('invalid_login'), life: 3000 });
                }
            );
        } else {
            toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: i18n.t('insert_params'), life: 3000 });
        }
    };

    return (
        <form onSubmit={handleLogin}>
            <Toast ref={toast} />
            <div className="login-body">
                <div className="card login-panel p-fluid">
                    <div className="login-panel-content">
                        <div className="grid">
                            <div className="col-12 logo-container flex">
                                <FontAwesomeIcon icon={faFire} className="text-indigo-600 text-6xl topbar-icon pi pi-fw pi-home mr-2" />
                                <div className="text-3xl mt-2 text-indigo-500">{appName}</div>
                            </div>
                            <div className="col-12 username-container mb-0 pb-0">
                                <label className="text-base">Korisničko ime</label>
                                <div className="login-input">
                                    <InputText className="p-inputtext-lg text-2xl" id="username" type="text" onChange={(e) => setEmail(e.target.value)} size="large" />
                                </div>
                            </div>
                            <div className="col-12 password-container">
                                <label className="text-base">Lozinka</label>
                                <div className="login-input">
                                    <InputText className="p-inputtext-lg text-2xl" type="password" onChange={(e) => setPassword(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-12 w-12">
                                <Button type="submit" label="Ulaz" icon="pi pi-check" className="bg-indigo-400 border-0" size="large" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};
